import {Store} from "redux";
import {v4 as uuidv4} from "uuid";
import {CommonAppState} from "../store/index";
import axios from "axios";
import AppSettings from "../types/AppSettings";

export const configureAxios = (store: Store<CommonAppState>, appSettings: AppSettings) => {
  var basePath = appSettings.basePath ? `/${appSettings.basePath}/` : "/";
  axios.defaults.baseURL = `${window.location.origin}${basePath}`;
  axios.interceptors.request.use(
    // Pre-request Handler
    function (config) {
      var appState = store.getState();
      if (appState.oidc.isLoadingUser || appState.oidc.user === undefined || appState.oidc.user.expired) {
        config.headers!.Authorization = "";
      } else {
        config.headers!.Authorization = `Bearer ${appState.oidc.user.access_token}`;
      }
      config.headers!.XCorrelationId = uuidv4();
      return config;
    },
    // Error Handler
    function (error) {
      return Promise.reject(error);
    }
  );
};
